import { Component } from "react";
import UserProfileBannerImg from '../../assets/images/user-profile-banner-img.jpg';

class UserProfileBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="user-profile-banner">

                <img src={UserProfileBannerImg} alt="User Profile Banner" />
                <ul>
                    <li>Remplissez ce formulaire pour obtenir votre badge de vérification gratuit</li>
                    <li>Accédez à des resources réservées aux membres vérifiés</li>
                    <li>Augmentez vos chances d’être contacté pour une opportunité correspondant à votre profil</li>
                </ul>
            </div>
        )
    }
}
export default UserProfileBanner;